import { Progress } from 'src/app/components/Elements/Progress';
import { Typography } from 'src/app/components/Elements/Typography';

import { CallToActionAnimationContainer, CallToActionButton } from './styles';

interface ArchiveBannerButtonProps {
  onClick: () => void;
  animateCollapse: boolean;
  isArchived: boolean;
  isLoading: boolean;
}

export const ArchiveBannerButton = ({ onClick, animateCollapse, isArchived, isLoading }: ArchiveBannerButtonProps) => {
  return (
    <>
      {!isLoading && (
        <CallToActionAnimationContainer animateCollapse={animateCollapse}>
          <CallToActionButton onClick={onClick}>
            <Typography variant="smallSpacedOut" color="capsuleGreen60">
              {isArchived ? 'UNARCHIVE' : 'ARCHIVE'}
            </Typography>
          </CallToActionButton>
        </CallToActionAnimationContainer>
      )}
      {isLoading && (
        <Progress
          size={30}
          thickness={4}
          color="inherit"
          style={{ marginLeft: '2rem', marginTop: '4rem', paddingBottom: '0' }}
        />
      )}
    </>
  );
};
